/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Invitation_ResentInputs */

const en_users_invitation_resent = /** @type {(inputs: Users_Invitation_ResentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitation email sent with a new temporary password.`)
};

const pt_br2_users_invitation_resent = /** @type {(inputs: Users_Invitation_ResentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail de convite enviado com uma nova senha temporária.`)
};

/**
* | output |
* | --- |
* | "Invitation email sent with a new temporary password." |
*
* @param {Users_Invitation_ResentInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_invitation_resent = /** @type {((inputs?: Users_Invitation_ResentInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Invitation_ResentInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_invitation_resent(inputs)
	return pt_br2_users_invitation_resent(inputs)
});